/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState} from "react"
import { useLocation,useSearchParams } from "react-router-dom"
import { limitReducer,resetArrays } from "../../redux/MultiselectRows"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import { useExportOrganizationUsersMutation } from "../../slices/apiSlice"
import { handleAddFilterValues, handleSystemConfig, handleSidebarPrvState } from "../../redux/systemConfigSlice"
import TopBarTemplate from "./Components/TopBarTemplate"
import TableTemplate from "./Components/TableTemplate"
import moment from "moment"
import { convertDatesToEpochUTC } from "../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import { useDeleteTemplateMutation, useGetMonitorTemplatesQuery } from "../../slices/monitorConditionTemplate"
import { dataService } from "../../services/data.services"
import OrganizationUserSearch from "../ManageOrganizationUsers/AdvancedSearch"
import { resetOrgUserSearch, setOrgUserSearchApplied } from "../../redux/orgUserSearchSlice"

export default function ManageMonitoringConditionTemplates(setdateError) {
    const {isSideBar, setIsSideBar, setToastmessage,setToastErrorMessage,isAdvancedSearchOpen, setIsAdvancedSearchOpen} = useContext(GlobalContext);
    
    const [exportOrganizationUsers]=useExportOrganizationUsersMutation()
    const [deleteTemplate]=useDeleteTemplateMutation()
    const [limit,setLimit]=useState("15")
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const dispatch=useDispatch()
    const [loading, setLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams({});
    const [confirmationState, setConfirmationState] = useState({isOpen:false,rowData:'',multirow:'',user_names:[]});
    const initialState={
        "start_date":'',
        "end_date":'',
    }
    const hasDateFilters = searchParams.get("start_date") !== null || searchParams.get("end_date") !== null;
    const [filterValues,setFilterValues]=useState(initialState)
    const [datePartialFilled,setDatePartialFilled] = useState(false);
    const searchApplied = useSelector((state) => state.orgUserSearchData.org_user_searchApplied);
    const organizationUserSearch = useSelector(state => state.orgUserSearchData);
    
     
    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });

    const {data,isFetching,isLoading,status, refetch}=useGetMonitorTemplatesQuery(searchParams?.toString(),{skip: skip||location.search===''})
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params[key] = value
        setSearchParams({ ...params})
    }
    useEffect(() => {
        if(location.search===''){
            setSkip(true)
        }

        if (location.state !== null && location.state !== '' && location?.state?.limit !== undefined && !Array.isArray(location.state)) {
            const { fromScreen, 'true': _fromEditFlag, id, user_id, object_id, ...restState } = location.state
            let params = { limit: '15', page_number: '1', ...restState };
            if (params.search) params.search = decodeURIComponent(params.search)
            else delete params.search
            setSearchParams(params)
            if (params.search_mode && !isAdvancedSearchOpen) {
                dispatch(handleSidebarPrvState(isSideBar))
                setIsAdvancedSearchOpen(true)
                setIsSideBar(false)
            }
        }
        else{
            const params = Object.fromEntries(searchParams)
            let changed = false
            if (!params.limit) { params.limit = '15'; changed = true }
            if (!params.page_number) { params.page_number = '1'; changed = true }
            if (changed) setSearchParams(params, { replace: true })
        }

    }, [location]);

    useEffect(()=>{
        if(searchParams.size>=2){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParams])

   
    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
       
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))
        }
       
        
    }, [data?.data]);

    const handleCheckboxChange = (event, type) => {
        const { id, checked } = event.target;
        setFilterValues((prevState) => {
            const newState = { ...prevState };
            newState[type] = checked
                ? [...(newState[type] || []), id]
                : (newState[type] || []).filter((item) => item !== id);
            return newState;
        });
    };

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if (type) {
            params.page_number=1
            params.filter = "true";
            const start_date=moment(filterValues?.start_date).format('YYYY-MM-DD')
            const end_date=moment(filterValues?.end_date).format('YYYY-MM-DD')
            
            // Dispatch the filter values to Redux
            dispatch(handleAddFilterValues({
                start_date: filterValues.start_date,
                end_date: filterValues.end_date
            }));
    
            // Filter out empty values before updating searchParams
            filterValues?.start_date !== "" && filterValues?.start_date !== undefined ? params["start_date"] = convertDatesToEpochUTC(start_date, Intl.DateTimeFormat().resolvedOptions().timeZone, true) : ''
            filterValues?.end_date !== "" && filterValues?.end_date !== undefined ? params["end_date"] = convertDatesToEpochUTC(end_date, Intl.DateTimeFormat().resolvedOptions().timeZone, false) : ''
            setSearchParams({...params})
        }
        else{
            params.start_date&&delete params.start_date
            params.end_date&&delete params.end_date
            delete params.filter
            setSearchParams({ ...params})
        }
    }

    // delete template
    const handleDelete = async (id) => {
        setLoading(true)        
        const res = await deleteTemplate(id)
        if (res?.error?.data?.message) {
            setToastErrorMessage(res?.error?.data?.message)
            setLoading(false)
        }
        else {
            setToastmessage('Monitoring conditions template deleted successfully');
            setLoading(false)
            
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dataService.GetAPI(`system-configuration/`);
                dispatch(handleSystemConfig(response.data.data))
            } catch (error) {
                console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);

    // apply search function
    const handleOnSubmit = (e) => {
        e.preventDefault();
        
        const searchParams = new URLSearchParams(window.location.search); // Use URLSearchParams
        
        const buildSearchString = (field, value, inverse, domain) => {
            if (!value && !domain) return ""; // Early exit if both are empty
            const prefix = inverse ? 'ne:' : '';
            const formattedValue = value === '-' ? '__NULL__' : (value?.trim() || ''); // Simplified NULL handling
            const formattedDomain = domain === '-' ? '__NULL__' : (domain?.trim() || '');
            if (domain) {
                return `${field}=${prefix}${encodeURIComponent(formattedValue)}@${encodeURIComponent(formattedDomain)};`;
            }
            return `${field}=${prefix}${encodeURIComponent(formattedValue)};`;
        };
        
        const buildPhoneSearchString = (field, code, number, inverse) => {
            if (!code && !number) return ""; // Early exit if both are empty
            const prefix = inverse ? 'ne:' : '';
            const formattedCode = code === '-' ? '__NULL__' : (code || '');
            const formattedNumber = number === '-' ? '__NULL__' : (number || '');
            return `${field}=${prefix}${formattedCode ? '+' : ''}${encodeURIComponent(formattedCode)}-${encodeURIComponent(formattedNumber)};`;
        };
        
        let searchString = "";
        
        searchString += buildSearchString("template_name", organizationUserSearch?.first_name, organizationUserSearch?.first_name_inverse);
        searchString += buildSearchString("created_by", organizationUserSearch?.last_name, organizationUserSearch?.last_name_inverse);
        

        const { created_day, created_month, created_year } = organizationUserSearch || {};
        const isPartialDateFilled = (created_day && (!created_month || !created_year)) || (created_month && (!created_day || !created_year)) || (created_year && (!created_day || !created_month));
        
        if (isPartialDateFilled) {

            setDatePartialFilled(true);
            return;

        } else if (created_day && created_month && created_year) {

            const dateStr = `${created_year}-${String(created_month).padStart(2, '0')}-${String(created_day).padStart(2, '0')}`;
            const epochDate = Math.floor(new Date(`${dateStr}T00:00:00`).getTime() / 1000);
            const prefix = organizationUserSearch.created_date_inverse ? 'ne:' : '';
            searchString += `created_at=${prefix}${epochDate};`;

        }
        
        searchString = searchString.slice(0, -1); // Remove trailing ';' (more efficient than endsWith)
        
        const newParams = {
            ...Object.fromEntries(searchParams),
            search: searchString || '',
            search_mode: organizationUserSearch.match === false ? 'and' : 'or',
            sort: searchParams.get('sort') || 'created_at+desc', // Use URLSearchParams.get
            page_number: 1,
            limit: searchParams.get('limit') || '15', // Use URLSearchParams.get
        };
        
        if (!newParams.search) delete newParams.search;
        
        window.history.pushState(null, "", `?${new URLSearchParams(newParams)}`); // Update URL directly
        setSearchParams(newParams); // This triggers the re-render
        dispatch(setOrgUserSearchApplied());
    };
        
    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetOrgUserSearch());
        }
    }, [dispatch, searchApplied]);
    
 
    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Monitoring Conditions Templates"}/>
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-3">
                        <TopBarTemplate 
                            title={'List of Monitoring Conditions Templates'}
                            path={'/manage-monitoring-condition-templates/add-template'}
                            AddButton={true}
                            buttonName={"Create Template"}
                            ApplyFilter={((searchParams.get("filter")===null)&&(data?.data?.length===0 || data===undefined))?false:true}
                            toAddScreen={'/manage-monitoring-condition-templates/add-template'}
                            setConfirmationState={setConfirmationState}
                            data={data}
                            isExport={true}
                            setdateError={setdateError}
                            exportCols={['Template Name','Created Date','Created By','Last Modified Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            initialState={initialState}
                            exportUsers={exportOrganizationUsers}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            handleCheckboxChange={handleCheckboxChange}
                            handleApplyFilter={handleApplyFilter}
                            
                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Monitoring Conditions Templates list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay':'overlay-list'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                        <div className="px-3">
                            <TableTemplate
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                setConfirmationState={setConfirmationState}
                                loading={loading}
                                handleDelete={handleDelete}
                            />
                        </div>
                        {data?.total_count>=15 &&<div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p id="total_records" className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(data?.success_status === "true") || (data?.total_count === 0 && searchParams.get("search")) ? (
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                        ) : null}

                        {data?.total_count === 0 && hasDateFilters && !searchParams.get("search") ? (
                            <SearchEmptyScreen text={"That filter combination has no result. Please try different criteria."} />
                        ) : null}

                        {data?.total_count === 0 && !hasDateFilters && !searchParams.get("search") ? (
                            <Emptyscreen
                                FirstPTag={"No Monitoring conditions template created yet"}
                                SecondePTag={"Click on ‘Create Template’ to create one"}
                            />
                        ) : null}

                        {(status === "rejected" || (data?.total_count !== 0 && data?.data?.length === 0)) ? (
                            <SearchEmptyScreen text={"No data found"} />
                        ) : null}
                    </>}
                </div>
                
            </div>
            {isAdvancedSearchOpen&&searchParams?.get('limit') &&
            <OrganizationUserSearch
                handleOnSubmit={handleOnSubmit}
                emptyField={datePartialFilled}
                setEmptyField={setDatePartialFilled}
                monitoringConditionSearch={true}
            />
            }
        </>
   
    )
}
